import React, { useState, useEffect } from 'react';
import { GetCredentialFileHistoryList } from '../../api/CredentialAPI';
import Loader from '../App/loader';
import NexusGrid from '../App/NexusGrid.js';

export default props => {
    const [loading, setLoading] = useState(true);
    const [credentialFileHistories, setCredentialFileHistories] = useState([]);

    useEffect(() => {
        loadCredentialFileHistories();
    }, []);

    const loadCredentialFileHistories = () => {
        setLoading(true);
        GetCredentialFileHistoryList({content: props.credentialID})
            .then(res => {
                if (res != null) {
                    if (res.success) {
                        setCredentialFileHistories(res.content);
                    }
                }
            });
        setLoading(false);
    }

    const headers = [
        { Header: "Name", accessor: "name" },
        { Header: "Active", accessor: "active" },
        { Header: "Change", accessor: "changeType" },
        { Header: "By", accessor: "changeBy" },
        { Header: "Date", accessor: "changeDate", dataFormat: (cell, row) => { return <div>{row.ChangeDate ? new Date(row.ChangeDate).toLocaleString() : ""}</div> } }
    ];

    return (loading ?
        <div className="NexusLoading">
            <Loader />
        </div> :
        <div>
            <h2>File History</h2>
            <NexusGrid
                data={credentialFileHistories}
                defaultSortBy={"Change"}
                defaultSortOrder={"desc"}
                columns={headers}
                pageMode="local"
            />

        </div>
    )
}